import { useMutation } from '@apollo/client/react'
import type { Patient as PatientV1 } from '@pbt/pbt-ui-components'

import { UpdatePatientsBatchDocument } from '~/api/graphql/generated/types'

export const useUpdatePatientsBatch = (
  businessId: string,
  clientId: string,
) => {
  const [updatePatientsBatch, { loading, error, reset }] = useMutation(
    UpdatePatientsBatchDocument,
  )

  return {
    updatePatientsBatchLoading: loading,
    updatePatientsBatchError: error,
    resetUpdatePatientsBatch: reset,
    updatePatientsBatch: (patients: PatientV1[]) => {
      if (!businessId || !clientId) {
        return
      }

      updatePatientsBatch({
        variables: {
          businessId,
          clientId,
          input: patients.map((patient) => ({
            id: patient.id,
            sendReminders: patient.sendReminders,
          })),
        },
      })
    },
  }
}
